import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchClient } from "@/lib/api-client";

export const useFetchBlogComments = (slug: string, limit = 20) =>
  useInfiniteQuery({
    queryKey: ["blog-comments", slug, limit],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await fetchClient.GET("/blog/{slug}/comments", {
        params: {
          path: { slug },
          query: { page: typeof pageParam === "number" ? pageParam : 1, limit },
        },
      });
      // response.data is typed `never` because the OpenAPI spec omits a response body;
      // cast through unknown to recover the runtime value.
      // biome-ignore lint/suspicious/noExplicitAny: untyped endpoint response
      return (response as unknown as { data?: unknown }).data as any;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      const p = lastPage?.data?.pagination as
        | { hasNextPage?: boolean; page?: number }
        | undefined;
      return p?.hasNextPage ? (p.page ?? 1) + 1 : undefined;
    },
    enabled: !!slug,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
